import moment, { Moment } from 'moment-timezone';

export const convertFromLocalToFleetTimezonePreservingLocalTime = (input: Date | string | Moment, timezone: string): Moment => {
  const localTz = moment.tz.guess();

  const momentInLocalTimezone = moment.tz(input, localTz);
  const momentInFleetTimezone = momentInLocalTimezone.tz(timezone, true);

  return momentInFleetTimezone;
};

export const convertFromFleetToLocalTimezonePreservingFleetTime = (input: Date | string | Moment, timezone: string): Moment => {
  const localTz = moment.tz.guess();

  const momentInFleetTimezone = moment.tz(input, timezone);
  const momentInLocalTimezone = momentInFleetTimezone.tz(localTz, true);

  return momentInLocalTimezone;
};

export const getDefaultDates = (timezone: string): { dateFrom: string; dateTo: string } => {
  const dateFrom = moment().subtract(1, 'week').startOf('day').tz(timezone).toISOString();
  const dateTo = moment.tz(timezone).toISOString();
  return { dateFrom, dateTo };
};
